import { FlexibleTableHeaderColumn } from "src/shared/components/data-display/FlexibleTable/flexible-table-items.interface"
import { HeaderProps } from "./useHeaderProps"

const useTipoVentaHeader = <T extends string>({headerValue, valueToDisplay}: HeaderProps<T>): FlexibleTableHeaderColumn => {

    const options = [
        { value: "Estancia", valueToDisplay: "Estancia" },
        { value: "Room service", valueToDisplay: "Room service" },
        { value: "Mostrador", valueToDisplay: "Mostrador" },
        { value: "Restaurante", valueToDisplay: "Restaurante" },
    ]

    return {
        value: headerValue,
        valueToDisplay,
        filterMenu: options,
        isFilterUnique: false,
        filterSuggetions: false,
    }
}

export default useTipoVentaHeader
